// extracted by mini-css-extract-plugin
export default {"container":"Unpressable_container__0eVS8","text_label":"Unpressable_text_label__J8WLg"};